export default __webpack_public_path__ + "static/media/calendar-tick.aeaf4428.svg";